import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Typography } from '../Typography';
import styles from './Card.module.scss';
export function Card(props) {
    const { className, padding, autoHeight, title, children, disableSeparator, actions, skin = 'default', as, highlightOnHover, testId, borderRadius = 's', borderSkin } = props, rest = _object_without_properties(props, [
        "className",
        "padding",
        "autoHeight",
        "title",
        "children",
        "disableSeparator",
        "actions",
        "skin",
        "as",
        "highlightOnHover",
        "testId",
        "borderRadius",
        "borderSkin"
    ]);
    const Component = as || 'div';
    return /*#__PURE__*/ _jsxs(Component, _object_spread_props(_object_spread({}, rest, testId != null ? {
        'data-testid': testId
    } : {}), {
        className: cn(styles.root, [
            styles[skin + 'Skin']
        ], {
            [styles[padding + 'Padding']]: !!padding,
            [styles.autoHeight]: autoHeight,
            [styles.highlightOnHover]: highlightOnHover,
            [styles[borderRadius + 'BorderRadius']]: !!borderRadius,
            [styles[borderSkin + 'BorderSkin']]: !!borderSkin
        }, className),
        children: [
            title && /*#__PURE__*/ _jsxs("div", {
                className: styles.titleRow,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        weight: "normal",
                        variant: "h5",
                        children: title
                    }),
                    actions && /*#__PURE__*/ _jsx("div", {
                        className: styles.actions,
                        children: actions
                    })
                ]
            }),
            title && !disableSeparator && /*#__PURE__*/ _jsx(Separator, {}),
            children
        ]
    }));
}
const Separator = ()=>/*#__PURE__*/ _jsx("div", {
        style: {
            width: '100%',
            minHeight: '1px',
            backgroundColor: 'var(--grey-semi)'
        }
    });
